import { all, call, put, takeLatest } from 'redux-saga/effects';
import { initiateRefundFail, initiateRefundSuccess, processPaymentFail, processPaymentSuccess } from './action';
import { IApplyDiscount, IInitiateRefund, IProcessPayment, IVerifyDiscount, types } from './types';
import { api } from '../../configurations/api';
import { initateRefundUrl, processPaymentUrl, verifyDiscountUrl } from '../../configurations/api/url';
import { httpRequest } from '../types';
import { globalErrorHandler } from '../error/saga';
import { SentryCapture } from '../../analytics/Sentry';
import { showToastMessage } from '../../utils/AppUtils';

function* verifyDiscountCode({
    payload,
    resolve,
    reject,
}: {
    payload: IVerifyDiscount;
    resolve: (value: IApplyDiscount | PromiseLike<IApplyDiscount>) => void;
    reject: (reason?: any) => void;
}): Generator<any, void, any> {
    try {
        const response = yield call(api, verifyDiscountUrl, httpRequest.POST, payload);
        const { data } = response;
        resolve(data);
    } catch (error: any) {
        reject(error);
        yield call(globalErrorHandler, error);
    }
}

function* processPayment({
    payload,
    resolve,
    reject,
}: {
    payload: IProcessPayment;
    resolve: any;
    reject: any;
}): Generator<any, void, any> {
    try {
        const response = yield call(api, processPaymentUrl, httpRequest.POST, payload, 0, 0);
        const { data } = response;
        yield put(processPaymentSuccess());
        yield call(showToastMessage, 'Payment processed successfully', 'success');

        if (resolve) {
            resolve(data);
        }
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(processPaymentFail(error.message || 'Payment failed'));

        if (reject) {
            reject(error);
        }
    }
}

function* initiateRefundSaga({
    payload,
    resolve,
    reject,
}: {
    payload: IInitiateRefund;
    resolve: (value: any) => Promise<void>;
    reject: (reason?: any) => Promise<void>;
}): Generator<any, void, any> {
    try {
        const { saleId, reason, details } = payload;
        const response = yield call(
            api,
            `${initateRefundUrl}/${saleId}/refund`,
            httpRequest.POST,
            {
                reason: `${reason}: ${details}`,
            },
            0,
            0,
        );
        const { data } = response;
        yield put(initiateRefundSuccess(data));
        yield call(showToastMessage, 'Refund request submitted successfully', 'success');

        if (resolve) {
            resolve(data);
        }
    } catch (error: any) {
        SentryCapture(error, 'error');
        yield call(globalErrorHandler, error);
        yield put(initiateRefundFail(error.message || 'Refund request failed'));

        if (reject) {
            reject(error);
        }
    }
}

function* checkoutWatcher() {
    yield takeLatest<any>(types.PROCESS_PAYMENT, processPayment);
    yield takeLatest<any>(types.INITIATE_REFUND, initiateRefundSaga);
}

function* verifyDiscountWatcher() {
    yield takeLatest<any>(types.VERIFY_DISCOUNT, verifyDiscountCode);
}

export default function* checkoutSaga() {
    yield all([checkoutWatcher(), verifyDiscountWatcher()]);
}
